module.exports = __webpack_public_path__ + "img/1N.5e9b4d08.jpg";